import { NavLink } from 'react-router-dom';
import { PAGES, SITE_NAME, site } from '../site';
import { asset } from '../site/assets';
import styles from './Header.module.css';

export function Header() {
    return (
        <div className="container">
            <header className={styles.header}>
                <nav aria-label="Navigation principale">
                    <ul className={styles.nav}>
                        {PAGES.filter((p) => p.inMenu).map((page) => (
                            <li key={page.path}>
                                <NavLink
                                    to={page.path}
                                    end={page.path === '/'}
                                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
                                >
                                    {page.path === '/' && (
                                        <img
                                            src={asset(site.logo)}
                                            height={site.logoHeight}
                                            alt=""
                                            className={styles.logo}
                                            style={{ height: site.logoHeight }}
                                        />
                                    )}
                                    {page.path === '/' ? site.headerLabel : (page.menuTitle ?? page.title)}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <span className="visually-hidden">{SITE_NAME}</span>
            </header>
        </div>
    );
}
